<template>
    <div class="pw-reset-component" v-if="showPwResetBox" @click.self="closePwResetBox">
        <div class="pw-reset-box">
            <div class="close-pw-reset-box" @click="closePwResetBox"></div>
            <div class="pw-reset-bg">
                <div class="text-bg"></div>
            </div>
            <div class="form-box">
                <div class="title-bar">
                    <div class="title">忘记密码</div>
                    <div class="back-btn" @click="swicthToLoginForm">
                        <img src="../assets/correcting-img/form-icon/back-to-login.png" alt="">
                        <span>返回登陆</span>
                    </div>
                </div>
                <el-form :model="passWordResetForm" status-icon :rules="rules" ref="passWordResetForm" class="pw-reset-ruleForm">
                    <div class="input-label"><img src="../assets/correcting-img/form-icon/phone.png" alt=""><span>手机号</span></div>
                    <el-form-item prop="phone">
                        <el-input type="text" v-model="passWordResetForm.phone" ref="pwResetPhoneInput" autocomplete="off" placeholder="请输入11位手机号"></el-input>
                    </el-form-item>
                    <div class="input-label"><img src="../assets/correcting-img/form-icon/identcode.png" alt=""><span>验证码</span></div>
                    <el-form-item prop="code">
                        <el-input type="text" v-model="passWordResetForm.code" autocomplete="off" placeholder="请输入验证码" class="identcode-input"></el-input>
                        <el-button plain :disabled="pwResetIdentCodeDisabled" @click="getIdentCode"><span v-if="reIndentCodeText">重新</span>获取验证码<span v-if="reIndentCodeNum">{{countdown}}</span></el-button>
                    </el-form-item>
                    <div class="input-label"><img src="../assets/correcting-img/form-icon/password.png" alt=""><span>新密码</span></div>
                    <el-form-item prop="password">
                        <el-input type="password" v-model="passWordResetForm.password" autocomplete="off" placeholder="请输入密码"></el-input>
                    </el-form-item>
                    <div class="input-label"><img src="../assets/correcting-img/form-icon/password.png" alt=""><span>确认密码</span></div>
                    <el-form-item prop="repassword">
                        <el-input type="password" v-model="passWordResetForm.repassword" autocomplete="off" placeholder="请再次输入密码" @keyup.enter.native="submitForm('passWordResetForm')"></el-input>
                    </el-form-item>
                    <el-form-item class="PwReset-submitBtn">
                        <el-button type="primary" :loading="pwResetBtnLoading" @click="submitForm('passWordResetForm')">确认修改</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import Axios from '@/api/Axios'
export default {
    name:"PwReset",
    props:["isShowPwResetBox"],
    data(){
        var checkPhone = (rule,value,callback) =>{
        var reg = /^1[0-9]{10}$/
            if (value === '') {
                callback(new Error('手机号码不能为空'));
                this.pwResetIdentCodeDisabled=true
            } else if (!reg.test(value)) {
                callback(new Error('请输入正确的手机号'));
                this.pwResetIdentCodeDisabled=true
            } else if (this.phoneIsLoginMessage===0) {
                callback(new Error('该手机号未注册'));
                this.pwResetIdentCodeDisabled=true
            } else {
                this.pwResetIdentCodeDisabled=false
                callback();
            }
        };
        var checkIdentCode = (rule,value,callback) =>{
            if (value === '') {
                callback(new Error('验证码不能为空'));
            } else {
                callback();
            }
        };
        var checkPassWord = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入密码'));
            } else {
                if (this.passWordResetForm.repassword !== '') {
                    this.$refs.passWordResetForm.validateField('repassword');
                }
                callback();
            }
        };
        var checkRePassWord = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.passWordResetForm.password) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        return{
            passWordResetForm:{                        //储存修改密码表单数据
                phone:'',
                code:'',
                password: '',
                repassword: ''
            },
            pwResetIdentCodeDisabled:true,             //控制获取验证码按钮防重复点击
            pwResetBtnLoading:false,                   //控制修改密码表单提交按钮Loading状态
            reIndentCodeText:false,                    //显示重新获取验证码文字
            reIndentCodeNum:false,                     //显示重新获取验证码倒计时数字
            countdown:30,                              //重新获取验证码倒计时
            timer:'',                                  //重新获取验证码倒计时定时器
            showPwResetBox:false,                      //控制忘记密码表单显示隐藏
            phoneIsLoginMessage:'',                    //判断手机号是否注册
            rules: {                               
                phone:[
                    {validator:checkPhone,trigger:'blur'}
                ],
                code:[
                    {validator:checkIdentCode,trigger:'blur'}
                ],
                password: [
                    { validator:checkPassWord, trigger: 'blur' }
                ],
                repassword: [
                    { validator:checkRePassWord, trigger: 'blur' }
                ]
            }
        }
    },
    watch:{
        //监听点击忘记密码事件
        isShowPwResetBox(){
            this.showPwResetBox=this.isShowPwResetBox
        },
        //监听手机号输入判断当前手机号是否注册过
        "passWordResetForm.phone":function(){
            if(this.passWordResetForm.phone.length===11){
                Axios.get('/phone/info',{"phone":this.passWordResetForm.phone}).then(
                    response=>{
                        if(response.data.code==200&&response.data.status=="success"){
                            this.phoneIsLoginMessage=response.data.data
                            if(response.data.data==0){
                                this.$refs.pwResetPhoneInput.blur()
                                this.pwResetIdentCodeDisabled=true
                            }
                            if(response.data.data==1){
                                this.$refs.pwResetPhoneInput.blur()
                                this.pwResetIdentCodeDisabled=false
                            }
                        }
                    },
                    error=>{
                        console.log(error)
                    }
                )
            }
        },
        //监听重新获取验证码倒计时
        countdown:function(){
            if(this.countdown<=0){
                clearInterval(this.timer);
                this.reIndentCodeNum=false;
                this.pwResetIdentCodeDisabled=false;
                this.countdown=30;
            }
        }
    },
    methods:{
        //关闭忘记密码弹窗
        closePwResetBox(){
            this.$emit("closePwReset",false)
        },
        //切换返回登陆弹窗
        swicthToLoginForm(){
            this.$emit("swicthToLoginForm",true)
        },
        //获取验证码
        getIdentCode(){
            Axios.post('sendsms',{"phone":this.passWordResetForm.phone,"login":1}).then(
                response=>{
                    if(response.data.code==200&&response.data.status=="success"){
                        this.pwResetIdentCodeDisabled=true;
                        this.reIndentCodeText=true;
                        this.reIndentCodeNum=true;
                        this.timer=setInterval(()=>{
                            this.countdown-=1;
                        },1000)
                    }
                },
                error=>{
                    console.log(error)
                }
            )
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.pwResetBtnLoading=true
                    Axios.post('editpwd',this.passWordResetForm).then(
                    response=>{
                        if(response.data.code==200&&response.data.data.errCode==1001){
                            this.pwResetBtnLoading=false
                            this.$message.error({
                                message:'验证码错误',
                                type:'error',
                                center:true,  
                                offset:100,
                                duration:900
                            })
                        }else if(response.data.code==200&&response.data.data.errCode==1000){
                            this.pwResetBtnLoading=false
                            this.$message.error({
                                message:'验证码错误',
                                type:'error',
                                center:true,  
                                offset:100,
                                duration:900
                            })
                        }else{
                            this.pwResetBtnLoading=false
                            this.$message.success({
                                message: '密码修改成功  请重新登录',
                                type: 'success',
                                center:true,
                                offset:100,
                                duration:900
                            })
                            setTimeout(()=>{this.$emit("swicthToLoginForm",true)},1400)
                        }
                    },
                    error=>{
                        this.pwResetBtnLoading=false
                        console.log(error)
                        this.$message.error({
                            message: '出错了  请稍后重试',
                            type: 'error',
                            center:true,
                            offset:100,
                            duration:900
                        });
                    }
                    )
                }else {
                    this.pwResetBtnLoading=false
                    this.$message.error({
                        message:'请正确填写各项信息',
                        type:'error',
                        center:true,
                        offset:100,
                        duration:900
                    });
                    return false
                }
            })
        }
    }
}
</script>
<style lang="scss">
.pw-reset-component{
    width:100%;
    height:100%;
    position:fixed;
    left:0;
    top:0;
    z-index:1000;
    background-color:rgba(0,0,0,.6);
    .close-pw-reset-box{
        width:32px;
        height:32px;
        background:url('../assets/correcting-img/close.png') no-repeat;
        background-size:cover;
        position:absolute;
        top:0;
        right:-50px;
        cursor:pointer;
    }
    .close-pw-reset-box:hover{
        opacity:.8;
    }
}
.pw-reset-box{
    position:absolute;
    width:776px;
    height:656px;
    background:#fff;
    border-radius:10px;
    top:50%;
    left:50%;
    transform: translate(-50%,-50%);
    display:flex;
    display:-webkit-flex;
    .pw-reset-bg{
        width:280px;
        height:656px;
        background:url('../assets/correcting-img/pw-reset-bg.png') no-repeat;
        background-size:cover;
        position:relative;
        .text-bg{
            width:166px;
            height:248px;
            background:url('../assets/correcting-img/login-logo.png') no-repeat;
            background-size:100% 100%;
            position:absolute;
            top:20%;
            left:50%;
            transform: translateX(-50%);
        }
    }
    .form-box{
        width:496px;
        padding:40px 50px;
        height:656px;
        .title-bar{
            display:flex;
            display:-webkit-flex;
            justify-content:space-between;
            height:35px;
            padding-bottom:16px;
            border-bottom:1px solid #E6E6E6;
            margin-bottom:20px;
            .title{
                width:76px;
                height:35px;
                padding-bottom:16px;
                text-align:center;
                font-size:18px;
                font-weight:bold;
                color:#222;
                border-bottom:2px solid #bf0000;
            }
            .back-btn{
                font-size:16px;
                color:#999;
                cursor:pointer;
                img,span{
                    vertical-align:middle;
                }
                img{
                    width:18px;
                    height:18px;
                    margin-right:10px;
                }
            }
            .back-btn:hover{
                opacity:0.8;
            }
        }
        .el-form-item{
            margin-bottom:28px !important;
        }
        .el-form-item__content{
            height:60px !important;
        }
        .input-label{
            height:22px;
            font-size:16px;
            color:#222;
            font-weight:bold;
            margin-top:14px;
            img,span{
                vertical-align:top;
            }
            img{
                margin-right:10px;
            }
        }
        .el-form-item__error{
            padding-left:26px !important;
        }
        .pw-reset-ruleForm{
            overflow:hidden;
        }
        .pw-reset-ruleForm input{
            border:none;
            border-bottom:1px solid #e6e6e6;
            font-size:16px;
            color:#7E7E7E;
            padding:20px 0;
            height:60px;
            width:370px;
            float:right;
            border-radius:0;
        }
        .pw-reset-ruleForm input::-webkit-input-placeholder{
            color:#ccc;
        }
        .pw-reset-ruleForm input::-moz-input-placeholder{
            color:#ccc;
        }
        .pw-reset-ruleForm input::-ms-input-placeholder{
            color:#ccc;
        }
        .PwReset-submitBtn{
            button{
                width:370px !important;
                height:50px;
                float:right;
                font-size:18px;
                margin-top:16px;
                background:#bd0003;
                border-radius:10px;
            }
            button:hover{
                background:#de7f81 !important;
                border:none;
            }
        }
        .el-button.is-plain{
            background-color:#fff !important;
            font-size:16px !important;
            position:absolute;
            right:0px;
            color:#BF0000;
            border:none !important;
            height:40px;
            top:50%;
            transform: translateY(-50%);
        }
        .el-button.is-disabled{
            color:#ccc !important;
        }
    }
}
</style>